import React from 'react';

const Services = () => {
    return (
        <div className="services-container" id="services-a" name="services">
            <div className="container-title">SERVICES</div>
            <div className="container-dashes"></div>
            <p className="container-text">We offer ipsum dolor sit amet, consetetur sadipscing elitr amet</p>
            <div className="services-items-container">
                <div className="service-item">
                    <div className="service-item-img s-i-i-1"></div>
                    <div className="service-item-title">CLEAN TYPOGRAPHY</div>
                    <div className="service-item-description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod soluta labore, magni animi voluptatum ex reiciendis suscipit voluptate minus possimus debitis illum in dicta aut esse. Minima eveniet ea iste!</div>
                </div>
                <div className="service-item">
                    <div className="service-item-img s-i-i-2"></div>
                    <div className="service-item-title">ROCK SOLID CODE</div>
                    <div className="service-item-description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod soluta labore, magni animi voluptatum ex reiciendis suscipit voluptate minus possimus debitis illum in dicta aut esse. Minima eveniet ea iste!</div>
                </div>
                <div className="service-item">
                    <div className="service-item-img s-i-i-3"></div>
                    <div className="service-item-title">EXPERT SUPPORT</div>
                    <div className="service-item-description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod soluta labore, magni animi voluptatum ex reiciendis suscipit voluptate minus possimus debitis illum in dicta aut esse. Minima eveniet ea iste!</div>
                </div>
            </div>
        </div>
    )
}

export default Services;